import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IContactForm } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  readonly url = 'https://us-central1-residuoscriativos.cloudfunctions.net/app';

  constructor(private http: HttpClient) {}

  sendEmail(form: IContactForm) {
    return this.http.post(`${this.url}/email`, form);
  }
}
